export default __webpack_public_path__ + "static/guardian2-3b1e0077160c17efe322880b7c516d50.png";